import { Check } from "lucide-react";
import { Reveal } from "../landing/shared";
import { SITE, IMAGES } from "@/config";

const TOPICS = [
  "Bowel habits",
  "Toilet routine",
  "Diet & fibre",
  "Hydration",
  "Straining",
  "When medical evaluation may be needed",
];

const Doctor = () => (
  <section data-testid="doctor-section" className="bg-navy py-14 sm:py-20">
    <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14 lg:px-8">
      <Reveal className="relative">
        <div className="absolute -left-3 -top-3 h-full w-full rounded-[1.75rem] border border-gold/40" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-[1.75rem] shadow-[0_25px_55px_-25px_rgba(0,0,0,0.6)]">
          <img
            src={IMAGES.doctor}
            alt="Dr. Burhan Shaikh"
            data-testid="doctor-photo"
            className="aspect-[4/5] w-full object-cover"
          />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold-soft">Doctor-led guidance</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-ivory sm:text-4xl" data-testid="doctor-headline">
            Not Just a Footstool.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-ivory/75 sm:text-lg" data-testid="doctor-copy">
            Your kit also includes{" "}
            <span className="font-semibold text-gold-soft">complimentary constipation counselling</span>{" "}
            by Dr. Burhan Shaikh.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <ul className="mt-7 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-testid="doctor-topics-list">
            {TOPICS.map((t) => (
              <li key={t} className="flex items-start gap-2.5 text-sm font-medium text-ivory/85">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15">
                  <Check className="h-3 w-3 text-gold" strokeWidth={3} />
                </span>
                {t}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.2} className="mt-9">
          <a
            data-testid="doctor-get-kit-button"
            href={SITE.razorpayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-gold px-9 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-navy shadow-[0_16px_38px_-12px_rgba(185,155,92,0.6)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-gold-soft active:translate-y-0"
          >
            Get my kit
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Doctor;
